import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IClientDetailsActions, IThunkArchiveTeam } from '../../types';

const onArchiveTeam: IThunkArchiveTeam = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload) => {
    const client = await api.clientTeams.archiveTeam(payload).then(r => r.data);

    setClientDetails({ actTeams: client.actTeams });
  },
);

export default onArchiveTeam;
